// frontend/src/components/Test/TestInstructions.js

import React from 'react';

const obtenerEstadoVisual = (prueba) => {
  const estado = prueba.estado_prueba || 'pendiente';
  if (estado === 'completada') return { icono: '✅', etiqueta: 'Completada' };
  if (estado === 'en_progreso') {
    return prueba.total_respondidas > 0
      ? { icono: '▶️', etiqueta: 'En progreso' }
      : { icono: '▶️', etiqueta: 'Siguiente' };
  }
  return { icono: '🔒', etiqueta: 'Pendiente' };
};

const TestInstructions = ({ testData, onStart }) => {
  const tieneProgreso = testData.pruebas.some(p => p.total_respondidas > 0);
  const pruebaActual = testData.pruebas.find(p => p.estado_prueba === 'en_progreso');

  return (
    <div className="test-instructions-container">
      <div className="instructions-card">
        <img
          src="/Logotransparente.png"
          alt="Logo"
          className="logo-img"
        />
        <h1>Instrucciones de la Prueba</h1>

        {tieneProgreso && (
          <div className="progress-notice">
            <div className="progress-notice-icon">📌</div>
            <div className="progress-notice-text">
              <strong>¡Bienvenido de vuelta!</strong><br />
              Continuarás exactamente donde la dejaste
              {pruebaActual ? <> — en <strong>{pruebaActual.nombre}</strong></> : ''}.
              No es necesario que vuelvas a responder preguntas ya contestadas.
            </div>
          </div>
        )}

        <div className="candidate-info">
          <p><b>Nombre:</b> {testData.asignacion.candidato.nombre}</p>
          <p><b>Correo:</b> {testData.asignacion.candidato.email}</p>
          <p><b>Empresa:</b> {testData.asignacion.empresa}</p>
        </div>

        <div className="tests-info">
          <h2>Pruebas a realizar:</h2>
          <ul>
            {testData.pruebas.map((prueba, index) => {
              const estado = prueba.estado_prueba || 'pendiente';
              const { icono, etiqueta } = obtenerEstadoVisual(prueba);
              return (
                <li key={index} className={`prueba-item-estado prueba-${estado}`}>
                  <div className="prueba-item-header">
                    <strong>{icono} {prueba.nombre}</strong>
                    <span className={`prueba-badge-estado badge-${estado}`}>{etiqueta}</span>
                  </div>
                  <p>{prueba.instrucciones || 'Sigue las instrucciones de cada pregunta.'}</p>
                  {prueba.tiempo_limite_segundos && (
                    <small>Tiempo estimado: {Math.floor(prueba.tiempo_limite_segundos / 60)} minutos</small>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="instructions-content">
          <h3>Instrucciones generales:</h3>
          <ul>
            <li>Lee cada pregunta cuidadosamente antes de responder.</li>
            <li>No hay respuestas correctas o incorrectas en las pruebas de personalidad.</li>
            <li>Responde con honestidad y espontaneidad.</li>
            <li>Una vez que avances a la siguiente pregunta, no podrás regresar.</li>
            <li>Las pruebas se realizan en el orden mostrado arriba: no puedes iniciar otra mientras haya una en progreso.</li>
            <li>Asegúrate de tener una conexión estable a internet.</li>
            <li>No cierres el navegador durante la prueba.</li>
            <li>Tus respuestas se guardan automáticamente; si te desconectas, podrás continuar desde donde ibas.</li>
          </ul>
        </div>

        <div className="test-actions">
          <button onClick={onStart} className="btn-start">
            {tieneProgreso ? `Continuar${pruebaActual ? ` en ${pruebaActual.nombre}` : ''}` : 'Comenzar Prueba'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestInstructions;
